export const getStateVisible = (country) => {
    const countryLower = country?.toLowerCase();
    if (countryLower === 'india' || countryLower === 'australia' || countryLower === 'united states' || countryLower === 'germany') {
        return true;
    }
    return false;
}
